import React, { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

/** Atoms */
import { SearchInput } from "@atoms/index";

/** Molecules */
import LanguageMenu from "@molecules/LanguageMenu";

/** Libraries */
import { Language, Search, Settings } from "@libraries/icons";

/** Languages */
import { TLanguages } from "@languages/languageData";

/** Styled components */
import * as Styled from "./styles";
import ProfileMenu from "../ProfileMenu";

interface Props {
  searchIsActive: boolean;
  setSearchIsActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavbarIcons: React.FC<Props> = ({
  searchIsActive,
  setSearchIsActive
}) => {
  const location = useLocation();

  const [languageElementAnchor, setLanguageElementAnchor] = React.useState<null | HTMLElement>(null);

  const handleLanguageClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setLanguageElementAnchor(event.currentTarget.parentElement);
  };

  const handleLanguageClose = (_language: TLanguages) => {
    setLanguageElementAnchor(null);
  };

  const [profileElementAnchor, setProfileElementAnchor] = React.useState<null | HTMLElement>(null);

  const handleProfileClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setProfileElementAnchor(event.currentTarget.parentElement);
  };

  const handleProfileClose = (_profile: string) => {
    setProfileElementAnchor(null);
  };

  const showSearch = useMemo(() => location.pathname !== "/", [location]);

  const searchContainer = useMemo(() => {
    if (searchIsActive) {
      return (
        <SearchInput
          searchIsActive={searchIsActive}
          setSearchIsActive={setSearchIsActive}
        />
      );
    }

    return <Search onClick={() => setSearchIsActive(!searchIsActive)} />;
  }, [searchIsActive, setSearchIsActive]);

  return (
    <Styled.Container searchIsActive={searchIsActive}>
      {showSearch ? (
        searchContainer
      ) : (
        <Styled.LanguageIcon>
          <Language onClick={handleLanguageClick} />
          <LanguageMenu
            anchorElement={languageElementAnchor}
            onClose={handleLanguageClose}
          />
        </Styled.LanguageIcon>
      )}
      <Styled.ManageAccountsIcon>
        <Settings onClick={handleProfileClick} />
        <ProfileMenu
          anchorElement={profileElementAnchor}
          onClose={handleProfileClose}
        />
      </Styled.ManageAccountsIcon>
    </Styled.Container>
  );
};

export default React.memo(NavbarIcons);
